import { addDefaultLocale } from "./date";

addDefaultLocale();

export function TimeAgoProvider({ children }: React.PropsWithChildren) {
  return children;
}
